export default __webpack_public_path__ + "static/media/ae.97c33bec.svg";